"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Services = require('./services');
module.exports = /*#__PURE__*/_createClass(function RecognitionAnywhereSdk(context) {
  var _this = this;
  _classCallCheck(this, RecognitionAnywhereSdk);
  if (!context) {
    throw new Error('context is required');
  }
  if (!context.fetch) {
    throw new Error('contextual fetch is required');
  }
  this.context = context;
  context.services = new Services(context);
  Object.keys(context.services).forEach(function (service) {
    _this[service] = context.services[service];
  });
  this.assets = {
    recognitionNow: {
      icon: 'https://api.biw.cloud/v1/images/b9d39933-2ebb-456e-8035-4d1d082d9f09',
      primaryBlack: 'https://api.biw.cloud/v1/images/70f87e93-24b8-40bf-bb86-fe3d36bedc2d',
      primaryColor: 'https://api.biw.cloud/v1/images/2a66aec5-bb58-4628-bed6-3faea0137c0b',
      primaryWhite: 'https://api.biw.cloud/v1/images/9540bae2-25c4-499d-b3bc-727af0fc1a03',
      secondaryBlack: 'https://api.biw.cloud/v1/images/10d18b2f-ce46-4737-964e-4181378a1ad5',
      secondaryColor: 'https://api.biw.cloud/v1/images/25d2b640-3a25-4e71-9364-515eeb3f86d0',
      secondaryWhite: 'https://api.biw.cloud/v1/images/e6787fb9-c34e-42cc-a1d9-99dd20c7432f'
    }
  };
});
//# sourceMappingURL=index.js.map